
import React from 'react';
import { AtSign } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import { useIsMobile } from '@/hooks/use-mobile';
import MentionsView from '@/components/notifications/MentionsView';

const Mentions = () => {
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-col min-h-screen w-full bg-black">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className={`flex-grow w-full mt-24 ${isMobile ? 'pb-20' : 'py-6 md:py-8 px-4 md:px-6 pb-6'}`}>
        <div className={`${isMobile ? 'px-4' : 'container mx-auto'}`}>
          {!isMobile && (
            <div className="mb-6">
              <div className="flex items-center gap-3 mb-2">
                <AtSign className="h-8 w-8 text-sports-green" />
                <h1 className="text-3xl font-bold text-white">Your Mentions</h1>
              </div>
              <p className="text-gray-300">
                Messages where you've been mentioned with @username
              </p>
            </div>
          )}

          <MentionsView />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default Mentions;
